// extracted by mini-css-extract-plugin
export default {"coopArea":"index_coopArea_PuvYA"};